const CLIENT_ID = 'g1rdbmzpwglbtm3c7m2vk87o8sz72x8j';
const LINK_TYPE = { DIRECT: 'direct', SHARED: 'shared' };
const MULTISELECT = false;


export default class BoxPicker {
  constructor(clientId = CLIENT_ID, linkType = LINK_TYPE.SHARED, multiSelect = MULTISELECT) {
    try {
      this.boxSelect = new BoxSelect({ clientId, linkType, multiselect: multiSelect });

      // Register a success callback handler
      this.boxSelect.success((response) => this.onSuccess(response));

      // Register a cancel callback handler
      this.boxSelect.cancel(this.onCancel);


      this.onPickSuccessCallback = undefined;
    } catch (e) {
      console.log('BoxSelect not loaded, more details: ', e.message);
    }
  }


  pick({ success: onPickSuccess }) {
    this.onPickSuccessCallback = onPickSuccess;

    this.boxSelect.launchPopup();
  }


  onSuccess(response) {
    this.onPickSuccessCallback({ response, url: response[0].url, name: response[0].name });
  }


  onCancel() {

  }
}
